import { Chip, paletteColors, Typography } from '@evaneos/b2b-ui';
import WarningIcon from '@evaneos/b2b-ui/icons/WarningAmber';
import { FormattedNumber, useIntl } from 'react-intl';

import { getElapsedMinOrHourSince } from '../../../shared/utilities/duration';

export type ElapsedTimeChipProps = {
    requestDate?: Date | null;
    now: Date;
    lateThresholdHours?: number; // default: 24
};

export const ElapsedTimeChip = ({
    requestDate,
    now,
    lateThresholdHours = 24,
}: ElapsedTimeChipProps) => {
    const { formatMessage } = useIntl();

    if (!requestDate) return null;

    const duration = getElapsedMinOrHourSince(requestDate, now);
    const isLate = duration.unit === 'hour' && duration.value >= lateThresholdHours;
    const messageId =
        duration.unit === 'minute' ? 'duration.minutes.short' : 'duration.hours.short';

    return (
        <Chip
            variant="filled"
            component="strong"
            label={
                <Typography component="strong" variant="body2" sx={{ fontWeight: 700 }}>
                    {formatMessage(
                        { id: messageId },
                        { value: <FormattedNumber value={duration.value} /> },
                    )}
                </Typography>
            }
            size="small"
            icon={isLate ? <WarningIcon /> : undefined}
            sx={{
                backgroundColor: isLate ? paletteColors.red[100] : paletteColors.blue[100],
                fontWeight: 700,
                '& svg': {
                    fill: paletteColors.red[800],
                },
            }}
        />
    );
};
